import { makeStyles } from "@material-ui/core/styles";
import colors from "@packages/ui/theme/colors";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import brandColors from "@packages/ui/theme/colors";
import { IconButton } from "@material-ui/core";

const brand = getBrandFromUrl().toLowerCase();

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    overflow: "hidden",
    width: "100%",
  },

  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },

  pdWeb: {
    paddingTop: 60,
    [theme.breakpoints.up("sm")]: { paddingTop: 69 },
  },

  contentContainer: {
    // display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3), // Add space around UI
    "@media (max-width: 320px)": {
      padding: theme.spacing(1),
    },
  },
  // headerWrapper: {
  //   display: "inline-block",
  //   textAlign: "center",
  //   padding: "10px",
  // },
  // content: {
  //   width: "100vw",
  //   "@media (max-width: 320px)": {
  //     maxWidth: "100%",
  //   },
  //   "@media (min-width: 768px)": {
  //     padding: theme.spacing(3),
  //     maxWidth: "550px",
  //   },
  //   "@media (min-width: 1440px)": {
  //     padding: theme.spacing(3),
  //     maxWidth: "1200px",
  //   },
  // },

  heading: {
    fontSize: "1.5rem", // Adjust font size to be smaller
    fontWeight: 600,
    textAlign: "center",
    fontFamily: "Ride",
    // display: "inline-block",
    // "@media (max-width: 767px)": {
    //   whiteSpace: "wrap",
    //   fontWeight: 200,
    //   fontSize: "1rem",
    // },
  },

  para: {
    fontSize: "1.1rem", // Adjust font size to be smaller
    fontFamily: "Ride",
    display: "flex", // Use flexbox for alignment
    alignItems: "center", // Align icon and text vertically
    gap: "12px", // Space between icon and text
    padding: "5px",
    width: "100%",
    "@media (max-width: 767px)": {
      fontWeight: 400,
      fontSize: "1rem",
      textAlign: "center",
    },
  },
  Icon: {
    color: colors.hertzHover,
    fontSize: "60px", // Optional: Adjust size
    textAlign: "center",
  },

  textFieldsBox: {
    minWidth: "0",
    width: "100%",
    maxWidth: "400px",
    "@media (max-width: 400px)": {
      maxWidth: "95vw",
    },
  },
  noWrapLabel: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
  },
  h1: {
    fontSize: "1.75rem", // Smaller h1 size
  },

  h2: {
    fontSize: "1.5rem", // Smaller h2 size
    fontWeight: 600,
  },

  title: {
    fontSize: "1.75rem", // Smaller h1 size
    "@media (max-width: 320px)": {
      fontSize: "1.3rem",
    },
  },
  descripe: {
    fontFamily: "Ride",
    "@media (max-width: 320px)": {
      fontSize: "12px",
    },
    "@media (min-width: 640px)": {
      fontSize: "18px",
    },
  },
  "landing-page-text": {
    fontFamily: "Ride",
    "@media (max-width: 375px)": {
      fontSize: "11px",
    },
    "@media (min-width: 640px)": {
      fontSize: "18px",
    },
  },
  button: {
    textTransform: "uppercase", // Capital letters for buttons
    width: "100%", // Fit across page
    justifyContent: "center",
    padding: theme.spacing(1.5),
    fontFamily: "Ride",
    fontWeight: 600,
  },
  flexContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wordFormat: {
    textTransform: "none",
    textAlign: "center",
    fontSize: "small",
  },
  radioFormat: {
    textTransform: "none",
    textAlign: "left",
    fontSize: "normal",
  },
  textStyles: {
    textAlign: "center",
  },
  breakLine: {
    borderWidth: "1px",
    borderStyle: "solid",
    margin: "0 auto",
    maxWidth: "100%",
    marginTop: "3px",
    "@media (max-width: 380px)": {
      maxWidth: "90%",
    },
    "@media (min-width: 768px)": {
      maxWidth: "650px",
    },
  },
  countryList: {
    fontFamily: "Roboto, sans-serif", // Match font family
    color: "#333", // Match text color
  },
  field: {
    margin: "10px 0",
  },
  signatureContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    // padding: "16px",
    borderRadius: "8px",
    textAlign: "center",
    marginTop: "15px",
    // marginBottom: "5px",
    fontWeight: "bold",
    maxWidth: "600px",
  },
  signatureBox: {
    border: "2px dashed #000",
    borderRadius: "8px",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    // marginBottom: "10px",
    width: "100%",
    maxWidth: "500px",
    minHeight: "150px",
    overflow: "hidden",
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
  },
  submitButton: {
    backgroundColor: "#ffd100",
    color: "#000",
    fontSize: "small",
  },
  clearButton: {
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #000",
    fontSize: "small",
  },
  horizontalLine: {
    position: "absolute",
    top: "70%",
    left: "0",
    width: "100%",
    height: "1px",
    backgroundColor: "#000",
  },
  IconButton: {
    position: "absolute",
    top: "10%",
    left: "90%",
    width: "10%",
    color: "#000",
    height: "1px",
    borderRadius: "30%",
  },
  "sms-text": {
    fontFamily: "Ride",
    fontSize: "12px",
    fontWeight: "500",
  },
  "sms-damage-code": {
    fontFamily: "Ride",
    fontSize: "16px",
    fontWeight: "bold",
  },
}));

export default useStyles;
